export const header = {
    pt: {
        home: "Início",
        about: "Sobre",
        projects: "Projetos",
        team: "Equipe",
        contact: "Contatos",
        contratar: "Entre em contato"
    },
    en: {
        home: "Home",
        about: "About",
        projects: "Projects",
        team: "Team",
        contact: "Contact",
        contratar: "Start a project"
    },
}